import { ShoppingBag, ClipboardList } from "lucide-react";

export const DEMO_EXIT_MS = 170;

export function demoEnterClass(dir) {
  if (dir === "left") return "demo-in-from-left";
  if (dir === "right") return "demo-in-from-right";
  return "";
}

export function demoExitClass(dir) {
  return dir === "left" ? "demo-out-to-right" : "demo-out-to-left";
}

/** Demo-only bottom switcher. Always visible, above sheets/overlays. */
export default function DemoSwitcherBar({ active, onSelect }) {
  return (
    <div className="demo-switcher" data-testid="demo-switcher">
      <div className="bg-white/95 backdrop-blur border border-orange-100 card-shadow rounded-full p-1 flex items-center gap-1">
        <Btn active={active === "customer"} onClick={() => onSelect("customer")} testid="demo-switch-customer">
          <ShoppingBag size={15} /> تجربة العميل
        </Btn>
        <Btn active={active === "owner"} onClick={() => onSelect("owner")} testid="demo-switch-owner">
          <ClipboardList size={15} /> إدارة المطعم
        </Btn>
      </div>
    </div>
  );
}

function Btn({ active, onClick, testid, children }) {
  return (
    <button onClick={onClick} data-testid={testid} aria-pressed={active}
      className={`pill px-4 py-2.5 text-xs sm:text-sm font-bold inline-flex items-center gap-1.5 transition-colors ${
        active ? "brand-grad text-white" : "bg-transparent text-gray-600"}`}>
      {children}
    </button>
  );
}
